import _typeof from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/typeof";
import "core-js/modules/es6.regexp.split";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import moment from "moment";
export default {
  name: "SiftBEDate",
  props: ["sift", "col", "label-width", "fold"],
  components: {},
  data: function data() {
    var _this = this;

    return {
      beginDate: null,
      endDate: null,
      beginOption: {
        disabledDate: function disabledDate(time) {
          if (_this.sift.min && time < _this.sift.min || _this.sift.max && time > _this.sift.max || _this.endDate && time > _this.endDate) {
            return true;
          }

          return false;
        }
      },
      endOption: {
        disabledDate: function disabledDate(time) {
          if (_this.sift.min && time < _this.sift.min || _this.sift.max && time > _this.sift.max || _this.beginDate && time < _this.beginDate) {
            return true;
          }

          return false;
        }
      }
    };
  },
  created: function created() {// if (this.sift.defaultValue) {
    //   const date = this.sift.defaultValue.split(",");
    //   this.beginDate = date[0];
    //   this.endDate = date[1];
    // }
  },
  mounted: function mounted() {},
  destroyed: function destroyed() {},
  methods: {
    setValue: function setValue(value) {
      if (typof(value) == "string") {
        var date = value.split(",");
        this.beginDate = date[0];
        this.endDate = date[1];
      } else if ((typeof obj === "undefined" ? "undefined" : _typeof(obj)) == "object" && obj.constructor == Array) {
        this.beginDate = value[0];
        this.endDate = value[1];
      }
    },
    getValue: function getValue() {
      if (this.sift.sysDatasourceQuery) {
        var keyName = this.sift.key.split(",");
        var _obj = {};
        var start = this.beginDate ? this.beginDate : null; // const end = this.endDate ? this.endDate + 86399000 : null;

        var end;

        if (this.endDate) {
          if (this.sift.pickerType === "datetime") {
            end = this.endDate;
          } else {
            end = this.endDate + 86399000;
          }
        }

        var sValue = null;
        var eValue = null;

        if (start) {
          var sYear = new Date(start).getFullYear();
          var sMonth = new Date(start).getMonth() + 1;
          sMonth = sMonth < 10 ? "0" + sMonth : sMonth;
          var sDate = new Date(start).getDate();
          sDate = sDate < 10 ? "0" + sDate : sDate;
          var sHour = new Date(start).getHours();
          sHour = sHour < 10 ? "0" + sHour : sHour;
          var sMinute = new Date(start).getMinutes();
          sMinute = sMinute < 10 ? "0" + sMinute : sMinute;
          var sSecond = new Date(start).getSeconds();
          sSecond = sSecond < 10 ? "0" + sSecond : sSecond; // sValue = `${sYear}-${sMonth}-${sDate}`;

          if (this.sift.pickerType === "datetime") {
            sValue = "".concat(sYear, "-").concat(sMonth, "-").concat(sDate, " ").concat(sHour, ":").concat(sMinute, ":").concat(sSecond);
          } else {
            sValue = "".concat(sYear, "-").concat(sMonth, "-").concat(sDate);
          }
        }

        if (end) {
          var eYear = new Date(end).getFullYear();
          var eMonth = new Date(end).getMonth() + 1;
          eMonth = eMonth < 10 ? "0" + eMonth : eMonth;
          var eDate = new Date(end).getDate();
          eDate = eDate < 10 ? "0" + eDate : eDate;
          var eHour = new Date(start).getHours();
          eHour = eHour < 10 ? "0" + eHour : eHour;
          var eMinute = new Date(start).getMinutes();
          eMinute = eMinute < 10 ? "0" + eMinute : eMinute;
          var eSecond = new Date(start).getSeconds();
          eSecond = eSecond < 10 ? "0" + eSecond : eSecond; // eValue = `${eYear}-${eMonth}-${eDate}`;

          if (this.sift.pickerType === "datetime") {
            eValue = "".concat(eYear, "-").concat(eMonth, "-").concat(eDate, " ").concat(eHour, ":").concat(eMinute, ":").concat(eSecond);
          } else {
            eValue = "".concat(eYear, "-").concat(eMonth, "-").concat(eDate);
          }
        } // obj[keyName] = [sValue, eValue];


        _obj[keyName[0]] = sValue;
        _obj[keyName[1]] = eValue;
        return _obj;
      } else {
        var _keyName = this.sift.key.split(",");

        var _obj2 = {};
        _obj2[_keyName[0]] = this.beginDate ? this.beginDate : null;
        _obj2[_keyName[1]] = this.endDate ? this.endDate + 86399000 : null;
        return _obj2;
      }
    },
    resetValue: function resetValue() {
      if (this.sift.indelible) {
        return;
      }

      this.beginDate = null;
      this.endDate = null;
    },
    changeValue: function changeValue() {
      if (this.beginDate && this.endDate || !this.beginDate && !this.endDate) {
        this.$emit("change");
      }
    }
  },
  watch: {
    "sift.defaultValue": {
      handler: function handler(val, oldVal) {
        var date = val.split(",");
        this.beginDate = date[0];
        this.endDate = date[1];
      },
      immediate: true
    },
    beginDate: function beginDate(val) {
      console.log(val);
    },
    endDate: function endDate(val) {
      console.log(val);
    }
  },
  filters: {}
};